import { useIdentity } from '@office-start/identity-service';
export var useIsCommercialUser = function () {
    var _a, _b;
    return (_b = (_a = useIdentity()) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.isOrgId;
};
//# sourceMappingURL=useIsCommercialUser.js.map